import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ResponseQueryByCriteria } from 'src/app/shared/dto/responseQueryByCriteria';
import { GenericService } from 'src/app/shared/GenericService';
import { environment } from 'src/environments/environment';
import { SoftwareDTO } from 'src/app/shared/dto/device-aziendali/software';
import { DeviceDTO } from 'src/app/shared/dto/device-aziendali/device';

@Injectable({
  providedIn: 'root'
})
export class SoftwareService extends GenericService<SoftwareDTO, number>{

  constructor(http: HttpClient) {
    super(http);
    this.url = environment.urlPrefix + '/services/rest/json/software';
  }

  public getTipologia(): Observable<string[]> {
    return this.http.get<string[]>(`${this.url}/tipologia`);
  }

  public softwareList(pageNumber: number, pageSize: number, direction: string, sortField: string, filter: string): Observable<ResponseQueryByCriteria<SoftwareDTO>> {
    let params = {};
    if (pageNumber != null) params["pageNumber"] = String(pageNumber);
    if (pageSize != null) params["pageSize"] = String(pageSize);
    if (direction != null) params["direction"] = direction;
    if (sortField != null) params["sortField"] = sortField;
    if (filter != null) params["filter"] = filter;
    return this.http.get<ResponseQueryByCriteria<SoftwareDTO>>(`${this.url}/softwareList`, {
      params: params
    });
  }

   public softwareDeviceList(pageNumber: number, pageSize: number, direction: string, sortField: string, filter: string, softwareId: number): Observable<ResponseQueryByCriteria<DeviceDTO>> {
    let params = {};
    if (pageNumber != null) params["pageNumber"] = String(pageNumber);
    if (pageSize != null) params["pageSize"] = String(pageSize);
    if (direction != null) params["direction"] = direction;
    if (sortField != null) params["sortField"] = sortField;
    if (filter != null) params["filter"] = filter;
    return this.http.get<ResponseQueryByCriteria<DeviceDTO>>(`${this.url}/${softwareId}/devices`, {
      params: params
    });
  }

}